 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER301THEDEVILPRINCEISHERE from '@/components/0_chapter301thedevilprinceishere'
 import A_CHAPTER302FIGHTAGAIN from '@/components/1_chapter302fightagain'
 import A_CHAPTER303CONSPIRACYRECONCILIATION from '@/components/2_chapter303conspiracyreconciliation'
 import A_CHAPTER304REJUVENATINGLILACCONTINENT from '@/components/3_chapter304rejuvenatinglilaccontinent'
 import A_CHAPTER305FINDANEWIDENTITY from '@/components/4_chapter305findanewidentity'
 import A_CHAPTER306SECRETSOFTHESAINTDEVILSECT from '@/components/5_chapter306secretsofthesaintdevilsect'
 import A_CHAPTER307DESCENDANTOFTHESAINTDEVILSECT from '@/components/6_chapter307descendantofthesaintdevilsect'
 import A_CHAPTER308ARRIVINGATSHENGDU from '@/components/7_chapter308arrivingatshengdu'
 import A_CHAPTER309VOTINGANDFORBIDDINGFORCES from '@/components/8_chapter309votingandforbiddingforces'
 import A_CHAPTER310IMPERIALGUARDACADEMYOFFICER from '@/components/9_chapter310imperialguardacademyofficer'
 import A0_CHAPTER311GUJIANYUNAPPEARED from '@/components/10_chapter311gujianyunappeared'
 import A1_CHAPTER312TOXICIRONSPIDER from '@/components/11_chapter312toxicironspider'
 import A2_CHAPTER313GOLDENSPIDER from '@/components/12_chapter313goldenspider'
 import A3_CHAPTER314IBEATTHESHITOUTOFYOU from '@/components/13_chapter314ibeattheshitoutofyou'
 import A4_CHAPTER315THEINFERNALKINGNEEDEDPOISON from '@/components/14_chapter315theinfernalkingneededpoison'
 import A5_CHAPTER316RUMORS from '@/components/15_chapter316rumors'
 import A6_CHAPTER317THEINFERNALKINGSLOVE from '@/components/16_chapter317theinfernalkingslove'
 import A7_CHAPTER318FEUDALFIEFDOMINTHEBLACKHELL from '@/components/17_chapter318feudalfiefdomintheblackhell'
 import A8_CHAPTER319OPENHOUSE from '@/components/18_chapter319openhouse'
 import A9_CHAPTER320FIRSTARRIVALFIEFDOM from '@/components/19_chapter320firstarrivalfiefdom'
 import A0_CHAPTER321BUYAMINER from '@/components/20_chapter321buyaminer'
 import A1_CHAPTER322MININGMINING from '@/components/21_chapter322miningmining'
 import A2_CHAPTER323OREDISCOVERED from '@/components/22_chapter323orediscovered'
 import A3_CHAPTER324STEALYOURHOUSEWHENYOUSEEANINJUSTICE from '@/components/23_chapter324stealyourhousewhenyouseeaninjustice'
 import A4_CHAPTER325ILIKETOTALKABOUTTHETERMSWITHAPONYTAIL from '@/components/24_chapter325iliketotalkaboutthetermswithaponytail'
 import A5_CHAPTER326LIONSMOUTH from '@/components/25_chapter326lionsmouth'
 import A6_CHAPTER327THEINFERNALKINGEXPLAINSFORYOU from '@/components/26_chapter327theinfernalkingexplainsforyou'
 import A7_CHAPTER328WHATISABOVECHAOS from '@/components/27_chapter328whatisabovechaos'
 import A8_CHAPTER329TROUBLESHOOTING from '@/components/28_chapter329troubleshooting'
 import A9_CHAPTER330JINHUANXILEAKEDTHENEWS from '@/components/29_chapter330jinhuanxileakedthenews'
 import A0_CHAPTER331MEETANOLDFRIENDINTHESHENGDU from '@/components/30_chapter331meetanoldfriendintheshengdu'
 import A1_CHAPTER332IMGONNADIGAHOLEFORYOU from '@/components/31_chapter332imgonnadigaholeforyou'
 import A2_CHAPTER333STEPPOINT from '@/components/32_chapter333steppoint'
 import A3_CHAPTER334TOSTEALTHENETHERGODIRON from '@/components/33_chapter334tostealthenethergodiron'
 import A4_CHAPTER335THESUDDENAPPEARANCEOFTHEINFERNALKING from '@/components/34_chapter335thesuddenappearanceoftheinfernalking'
 import A5_CHAPTER336THEINFERNALKINGSSUSPICION from '@/components/35_chapter336theinfernalkingssuspicion'
 import A6_CHAPTER337WANGDAOCHENGRETURNEDTOSHENGDU from '@/components/36_chapter337wangdaochengreturnedtoshengdu'
 import A7_CHAPTER338SLAUGHTERCITY from '@/components/37_chapter338slaughtercity'
 import A8_CHAPTER339CONTROLLINGTIGERSTOLEAVETHEMOUNTAIN from '@/components/38_chapter339controllingtigerstoleavethemountain'
 import A9_CHAPTER340SNEAKATTACKONSKYDRAGONCONTINENT from '@/components/39_chapter340sneakattackonskydragoncontinent'
 import A0_CHAPTER341GREENSNAKEWITHDRAWAL from '@/components/40_chapter341greensnakewithdrawal'
 import A1_CHAPTER342THEHEAVENLYARMYISABOUTTOARRIVE from '@/components/41_chapter342theheavenlyarmyisabouttoarrive'
 import A2_CHAPTER343ANTERIORANDPOSTERIORPINCERS from '@/components/42_chapter343anteriorandposteriorpincers'
 import A3_CHAPTER344YOUWANTMETONEGOTIATEWITHTHEM from '@/components/43_chapter344youwantmetonegotiatewiththem'
 import A4_CHAPTER345DEMONFIGHTINGARRAY from '@/components/44_chapter345demonfightingarray'
 import A5_CHAPTER346PACIFY from '@/components/45_chapter346pacify'
 import A6_CHAPTER347SURVEY from '@/components/46_chapter347survey'
 import A7_CHAPTER348ASADRUNK from '@/components/47_chapter348asadrunk'
 import A8_CHAPTER349JINSHIANSREQUEST from '@/components/48_chapter349jinshiansrequest'
 import A9_CHAPTER350SECONDARYSELECTION from '@/components/49_chapter350secondaryselection'
 import A0_CHAPTER351NEARINGTHEYELLOWSPRINGSPLANEAGAIN from '@/components/50_chapter351nearingtheyellowspringsplaneagain'
 import A1_CHAPTER352HISIDENTITYHADLONGBEENREVEALED from '@/components/51_chapter352hisidentityhadlongbeenrevealed'
 import A2_CHAPTER353PHANTOMPOISONOUSFROG from '@/components/52_chapter353phantompoisonousfrog'
 import A3_CHAPTER354REDSNAKEDEMONEMPRESS from '@/components/53_chapter354redsnakedemonempress'
 import A4_CHAPTER355TOBESOLDATPRICE from '@/components/54_chapter355tobesoldatprice'
 import A5_CHAPTER356SNEAKATTACKFROMBEHIND from '@/components/55_chapter356sneakattackfrombehind'
 import A6_CHAPTER357LIDAIPEACHSTIFF from '@/components/56_chapter357lidaipeachstiff'
 import A7_CHAPTER358CUTDOWNGRASSANDROOT from '@/components/57_chapter358cutdowngrassandroot'
 import A8_CHAPTER359SFENGSHUANGSPAST from '@/components/58_chapter359sfengshuangspast'
 import A9_CHAPTER360PLANNINGROBBERY from '@/components/59_chapter360planningrobbery'
 import A0_CHAPTER361DEMONICLUODIVINEGENERAL from '@/components/60_chapter361demonicluodivinegeneral'
 import A1_CHAPTER362NINETAILEDWHITEFOX from '@/components/61_chapter362ninetailedwhitefox'
 import A2_CHAPTER363INSERTIONREACTION from '@/components/62_chapter363insertionreaction'
 import A3_CHAPTER364MASTERING from '@/components/63_chapter364mastering'
 import A4_CHAPTER365CAUSINGAHUGERUCKUSINSHENGDU1 from '@/components/64_chapter365causingahugeruckusinshengdu1'
 import A5_CHAPTER366MAKINGARUCKUSINSHENGDU2 from '@/components/65_chapter366makingaruckusinshengdu2'
 import A6_CHAPTER367MAKINGARUCKUSINSHENGDU3 from '@/components/66_chapter367makingaruckusinshengdu3'
 import A7_CHAPTER368SHENGDUS4 from '@/components/67_chapter368shengdus4'
 import A8_CHAPTER369THEINFERNALKINGSTRUEBODYAPPEARED from '@/components/68_chapter369theinfernalkingstruebodyappeared'
 import A9_CHAPTER370OLDMRANDMRSLI from '@/components/69_chapter370oldmrandmrsli'
 import A0_CHAPTER371EXTERMINATINGSTRONGENEMY from '@/components/70_chapter371exterminatingstrongenemy'
 import A1_CHAPTER372THIRTYSIXGENERALSOFTHETHUNDERCLAN from '@/components/71_chapter372thirtysixgeneralsofthethunderclan'
 import A2_CHAPTER373BEHEADINGTHEINFERNALKINGSCLONE1 from '@/components/72_chapter373beheadingtheinfernalkingsclone1'
 import A3_CHAPTER374BEHEADINGTHEINFERNALKINGSCLONE2 from '@/components/73_chapter374beheadingtheinfernalkingsclone2'
 import A4_CHAPTER375BEHEADINGTHEINFERNALKINGSCLONE3 from '@/components/74_chapter375beheadingtheinfernalkingsclone3'
 import A5_CHAPTER376REUNIONAFTERALONGABSENCE from '@/components/75_chapter376reunionafteralongabsence'
 import A6_CHAPTER377DIVIDEDMAGICALEQUIPMENTFORDEALINGWITHRICHPEOPLE from '@/components/76_chapter377dividedmagicalequipmentfordealingwithrichpeople'
 import A7_CHAPTER378DARKNESSISETERNITY from '@/components/77_chapter378darknessiseternity'
 import A8_CHAPTER379ANOTHERDEALOFTHREEHUNDREDYEARS from '@/components/78_chapter379anotherdealofthreehundredyears'
 import A9_CHAPTER380ENTANGLEMENT from '@/components/79_chapter380entanglement'
 import A0_CHAPTER381THERULESOFTHESIXPATHSOFSAMSARA from '@/components/80_chapter381therulesofthesixpathsofsamsara'
 import A1_CHAPTER382DEADSPACE from '@/components/81_chapter382deadspace'
 import A2_CHAPTER383STRONGSTARCONTINENT from '@/components/82_chapter383strongstarcontinent'
 import A3_CHAPTER384FAMILIARFIGURE from '@/components/83_chapter384familiarfigure'
 import A4_CHAPTER385WHITEJADE from '@/components/84_chapter385whitejade'
 import A5_CHAPTER386RETURNTOEARTH from '@/components/85_chapter386returntoearth'
 import A6_CHAPTER387FIREPARTLUOXUAN from '@/components/86_chapter387firepartluoxuan'
 import A7_CHAPTER388BOLDBEAUTY from '@/components/87_chapter388boldbeauty'
 import A8_CHAPTER389LISHAN from '@/components/88_chapter389lishan'
 import A9_CHAPTER390SECRETREALM from '@/components/89_chapter390secretrealm'
 import A0_CHAPTER391THEIDENTITYOFANENEMY from '@/components/90_chapter391theidentityofanenemy'
 import A1_CHAPTER392UNIVERSALHEARTMERIDIAN from '@/components/91_chapter392universalheartmeridian'
 import A2_CHAPTER393ANCESTORSMETHODOFLECTURING from '@/components/92_chapter393ancestorsmethodoflecturing'
 import A3_CHAPTER394PANGUKAITIAN from '@/components/93_chapter394pangukaitian'
 import A4_CHAPTER395THREEREALMSSIXDAOS from '@/components/94_chapter395threerealmssixdaos'
 import A5_CHAPTER396BYTHELOCALTYRANTS from '@/components/95_chapter396bythelocaltyrants'
 import A6_CHAPTER397THEGREATIMMORTALBATTLE from '@/components/96_chapter397thegreatimmortalbattle'
 import A7_CHAPTER398SOULREAPER from '@/components/97_chapter398soulreaper'
 import A8_CHAPTER399FOODIEBEAUTY from '@/components/98_chapter399foodiebeauty'
 import A9_CHAPTER400ALMOSTWRONG from '@/components/99_chapter400almostwrong'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter301thedevilprinceishere",
 			"name" : "0_chapter301thedevilprinceishere",
 			"component" : A_CHAPTER301THEDEVILPRINCEISHERE
 		},
 		{
 			"path" : "/1_chapter302fightagain",
 			"name" : "1_chapter302fightagain",
 			"component" : A_CHAPTER302FIGHTAGAIN
 		},
 		{
 			"path" : "/2_chapter303conspiracyreconciliation",
 			"name" : "2_chapter303conspiracyreconciliation",
 			"component" : A_CHAPTER303CONSPIRACYRECONCILIATION
 		},
 		{
 			"path" : "/3_chapter304rejuvenatinglilaccontinent",
 			"name" : "3_chapter304rejuvenatinglilaccontinent",
 			"component" : A_CHAPTER304REJUVENATINGLILACCONTINENT
 		},
 		{
 			"path" : "/4_chapter305findanewidentity",
 			"name" : "4_chapter305findanewidentity",
 			"component" : A_CHAPTER305FINDANEWIDENTITY
 		},
 		{
 			"path" : "/5_chapter306secretsofthesaintdevilsect",
 			"name" : "5_chapter306secretsofthesaintdevilsect",
 			"component" : A_CHAPTER306SECRETSOFTHESAINTDEVILSECT
 		},
 		{
 			"path" : "/6_chapter307descendantofthesaintdevilsect",
 			"name" : "6_chapter307descendantofthesaintdevilsect",
 			"component" : A_CHAPTER307DESCENDANTOFTHESAINTDEVILSECT
 		},
 		{
 			"path" : "/7_chapter308arrivingatshengdu",
 			"name" : "7_chapter308arrivingatshengdu",
 			"component" : A_CHAPTER308ARRIVINGATSHENGDU
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js